import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectFieldOption } from '@sdbn/common';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject, Subscription } from 'rxjs';
import { TransportType } from '../../../common/model/transport.model';
import { TmcContextService } from '../../../common/tmc-context.service';

@Component({
  selector: 'yard-transport-option-condition-editor',
  standalone: false,
  templateUrl: './transport-option-condition-editor.component.html',
  styleUrl: './transport-option-condition-editor.component.scss',
})
export class TransportOptionConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    value: new FormControl(null, [])
  });

  selectFieldOptions: Array<SelectFieldOption>;
  tmcContextSubscription: Subscription;

  constructor(
    private tmcContextService: TmcContextService
  ) {

  }

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    let selectFieldOptions = new Array<SelectFieldOption>();
    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        for (const to of this.tmcContextService.getYardConfiguration().transportOptions) {
          selectFieldOptions.push(new SelectFieldOption({ labelDictionaryKey: to.nameDictionaryKey, value: to.id }));
          for (const childTo of to.transportOptions) {
            selectFieldOptions.push(new SelectFieldOption({ labelDictionaryKey: childTo.nameDictionaryKey, value: childTo.id }));
          }
        }
      }
    });
    this.selectFieldOptions = selectFieldOptions;

    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.value;
    });

    for (const key of Object.keys(TransportType)) {
    }

  }

}
